import { render, staticRenderFns } from "./TheSidebarHeader.vue?vue&type=template&id=bbbae67c&"
import script from "./TheSidebarHeader.vue?vue&type=script&lang=js&"
export * from "./TheSidebarHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarHeader.vue?vue&type=style&index=0&id=bbbae67c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports